export interface Partner {
	name: string;
	image: string;
}

export const carsPartners: Partner[] = [
	{ name: 'kayak', image: '/images/companies/kayak.png?v1.1' },
	{ name: 'expedia', image: '/images/companies/expedia.png?v1.1' },
	{ name: 'skyscanner', image: '/images/companies/skyscanner.png?v1.1' },
	{ name: 'rentalcars', image: '/images/companies/rentalcars.png?v1.1' }, // placeholder
	{ name: 'autorentals', image: '/images/companies/autorentals.png?v1.1' },
	{ name: 'wego', image: '/images/companies/wego.png?v1.1' }, // placeholder
	{ name: 'enjoytravel', image: '/images/companies/enjoytravel.png?v1.1' },
	{ name: 'momondo', image: '/images/companies/momondo.png?v1.1' },
];

export const flightsPartners: Partner[] = [
	{ name: 'kayak', image: '/images/companies/kayak.png?v1.1' },
	{ name: 'skyscanner', image: '/images/companies/skyscanner.png?v1.1' },
	{ name: 'cheapflights', image: '/images/companies/cheapflights.png?v1.1' },
	{ name: 'wego', image: '/images/companies/wego.png?v1.1' },
	{ name: 'expedia', image: '/images/companies/expedia.png?v1.1' }, // placeholder
	{ name: 'momondo', image: '/images/companies/momondo.png?v1.1' },
];

export const hotelsPartners: Partner[] = [
	{ name: 'kayak', image: '/images/companies/kayak.png?v1.1' },
	{ name: 'expedia', image: '/images/companies/expedia.png?v1.1' },
	{ name: 'booking', image: '/images/companies/booking.png?v1.1' }, // placeholder
	{ name: 'hotels', image: '/images/companies/hotels-com.png?v1.1' },
	{ name: 'skyscanner', image: '/images/companies/skyscanner.png?v1.1' }, // placeholder
	{ name: 'momondo', image: '/images/companies/momondo.png?v1.1' },
	{ name: 'priceline', image: '/images/companies/priceline.png?v1.1' }, // placeholder
];

export const cruisePartners: Partner[] = [
	{ name: 'priceline', image: '/images/companies/priceline.png?v1.1' },
	{ name: 'expedia', image: '/images/companies/expedia.png?v1.1' },
	{ name: 'cruise-direct', image: '/images/companies/cruise-direct.png?v1.1' },
	{ name: 'cruise-com', image: '/images/companies/cruises-com.png?v1.1' },
];

interface PartnersMap {
	[key: string]: string;
}

export const partnersMap: PartnersMap = {
	k: 'kayak',
	ex: 'expedia',
	s: 'skyscanner',
	r: 'rentalcars',
	a: 'autorentals',
	w: 'wego',
	et: 'enjoytravel',
	cf: 'cheapflights',
	b: 'booking',
	h: 'hotels',
};

export const partnerAltName: PartnersMap = {
	prf: 'expedia',
};
